// src/pages/checkout.js
import React from 'react';
import Header from '../../containers/Layout/Header';
import Footer from '../../containers/Layout/Footer';
import SEO from '../../components/seo';
import PageHeader from '../../components/pageheader';
import CheckoutPagarme from '../../components/CheckoutPagarme';
import { Wrapper } from '../../containers/contact-form-area/contact-form-area.style';
import { Col, Container, Row } from '../../components/ui/Wrapper';

export default function CheckoutPage({ location, pageContext }) {
  return (
    <>
      <SEO title="Checkout - Pagamento" location={location} />
      <Header />
      <PageHeader pageContext={pageContext} location={location} title="Pagamento" />
      <Wrapper>
        <Container>
          <Row>
            <Col lg={12} ml="auto">
              <CheckoutPagarme />
            </Col>
          </Row>
        </Container>
      </Wrapper>
      <Footer />
    </>
  );
}
